import { atom } from "recoil";

export const barcodeDataState = atom({
  key: "barcodeDataState",
  default: [],
});
